import React, { useRef } from 'react'
import { generatePath, Link } from 'react-router-dom'
import TableComponent, { TableComponentType } from 'UI/Table'
import { IColumn } from 'typescript/interfaces/tableUi'
import { useTableComponentStyle } from 'UI/Table/style'
import { DEAL_INFO_URL } from 'constants/routes'
import { IDiscountReportListItem } from 'typescript/interfaces/discountReport'
import { convertDate, convertEmptyField, convertToPriceFormat } from 'utils/formatters'

export const TableDiscountReport = TableComponent as TableComponentType<IDiscountReportListItem>

export const useDiscountReport = () => {
  const classes = useTableComponentStyle({})
  const columns = useRef<Array<IColumn<IDiscountReportListItem>>>([
    {
      label: 'Deal ID #',
      field: 'dealId',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data =>
        data.dealId ? (
          <Link to={generatePath(DEAL_INFO_URL, { id: data.dealId.toString() })}>#{data.dealId}</Link>
        ) : (
          `#${convertEmptyField(data.dealId)}`
        ),
    },
    {
      label: 'Deal Name',
      field: 'dealName',
      bodyCellClassName: classes.accentCell,
      render: data => convertEmptyField(data.dealName),
    },
    {
      label: 'Payment Date',
      field: 'paymentDate',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data => convertDate(data.paymentDate),
    },
    {
      label: 'Early Payoff Value',
      field: 'earlyPayoffValue',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data => convertToPriceFormat(data.earlyPayoffValue),
    },
  ])

  return {
    columns: columns.current,
  }
}
